// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"64":"fa4ea9a9","335":"0284154a","451":"0284154a","538":"079656bd","959":"0284154a"}[chunkId] + ".chunk.css";
};